import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import * as _ from "lodash";
import { setInteractionMode } from "vee-validate";
import simplebar from "simplebar-vue";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { AssetMasterModule } from "@/store/modules/asset.module";
import { Guid } from "guid-typescript";
import { AssetAssignmentEditModel } from "@/store/models/asset/assetAssignmentEditDTO";
import { AssetAssignmentModel } from "@/store/models/asset/assetAssignmentDTO";
import assetAssignmentMachine from "./machines/AssetAssignmentMachine";
import { interpret } from "xstate";
import { AssignedAssetsModel } from "@/store/models/asset/assignedAsset";
import DeleteComponent from "@/components/deleteComponent.vue";
/**
 *  Asset Assignment
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let AssetAssignment = /** @class */ (() => {
    let AssetAssignment = class AssetAssignment extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.searchLookupAsset = "";
            this.pageIsLoading = false;
            this.title = "Asset Assignment";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Assets",
                    href: "#",
                },
                {
                    text: "Asset Assignment",
                    active: true,
                },
            ];
            this.asset = new AssignedAssetsModel();
            this.assetAssign = new AssetAssignmentModel();
            this.selectedWorkPlace = new AssetAssignmentEditModel();
            this.selectedAssetId = "";
            this.searchKey = "";
            this.showLookupModal = false;
            this.selectedIssueLetterAssets = [];
            this.selectedReturnLetterAssets = [];
            this.returnLetterConditions = {};
            //Machines
            this.machine = assetAssignmentMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        showModal(empId) {
            this.selectedAssetId = null;
            this.machineService.send({ type: "ASSET_LOOKUP", employeeId: empId });
        }
        backToAsset() {
            this.machineService.send({ type: "CLOSE_MODAL" });
            this.searchLookupAsset = "";
            this.assetsData.length = 0;
        }
        get employeeList() {
            this.selectedEmployeeId = AssetMasterModule.employeeListing[0]?.employeeId;
            return AssetMasterModule.employeeListing;
        }
        get assignedAssets() {
            return AssetMasterModule.assetAssignment;
        }
        getFullName() {
            return this.employeeLists.find((x) => x.employeeId == this.selectedEmployeeId).fullName;
        }
        get employeeLists() {
            return _.sortBy(AssetMasterModule.employeeListing, (item) => item.fullName);
        }
        get filteredEmployeeList() {
            if (this.searchKey != "") {
                return AssetMasterModule.employeeListing.filter((x) => x.fullName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return AssetMasterModule.employeeListing;
        }
        GetEmployeesAssets(empId) {
            this.selectedEmployeeId = empId;
            this.send({ type: "CHANGE_EMPLOYEE", employeeId: empId });
        }
        UpdateWorkPlace() {
            this.selectedWorkPlace.id = this.assignedAssets.employeeId;
            this.selectedWorkPlace.workPlace = this.assignedAssets.workPlace;
            this.send({ type: "CHANGE_WORK_PLACE", payload: this.selectedWorkPlace });
        }
        confirmAssignAsset() {
            if (this.selectedAssetId != null) {
                this.machineService.send({
                    type: "ASSIGNING_ASSET",
                    payLoad: this.assetAssign,
                });
                AssetMasterModule.ClearAssetData();
                this.searchLookupAsset = "";
            }
        }
        assetRecordClick(assetId) {
            this.selectedAssetId = assetId;
            this.assetAssign.assetId = assetId;
            this.assetAssign.employeeId = this.assignedAssets.employeeId;
        }
        searchDataByFilter() {
            if (this.searchLookupAsset.length > 0) {
                this.machineService.send({ type: "SEARCH", str: this.searchLookupAsset });
            }
            else {
                AssetMasterModule.ClearAssetData();
                this.searchLookupAsset = null;
                this.machineService.send({ type: "SEARCH", str: this.searchLookupAsset });
            }
        }
        showRemoveConfirmation(assetId) {
            this.assetId = assetId;
            this.machineService.machine.context.empId = this.selectedEmployeeId;
            this.send({ type: "REMOVE_ASSIGNED_ASSET", assetId: assetId });
        }
        removeAssetAssignment() {
            this.send({ type: "CONFIRM_ASSET_REMOVE", assetId: this.assetId });
        }
        clearAssetLookupData() {
            this.searchLookupAsset = "";
            AssetMasterModule.ClearAssetData();
        }
        printIssueLetter() {
            this.machineService.send({ type: "PRINT_ISSUE_LETTER", employeeId: this.assignedAssets.employeeId });
        }
        toggleAllIssueLetterAssets(event) {
            if (event.target.checked) {
                this.selectedIssueLetterAssets = this.assignedAssets.assets.map((a) => a.assetId);
            }
            else {
                this.selectedIssueLetterAssets = [];
            }
        }
        toggleIssueLetterAsset(assetId) {
            const idx = this.selectedIssueLetterAssets.indexOf(assetId);
            if (idx === -1) {
                this.selectedIssueLetterAssets.push(assetId);
            }
            else {
                this.selectedIssueLetterAssets.splice(idx, 1);
            }
        }
        exportIssueLetter() {
            this.send({ type: "EXPORT_ISSUE_LETTER", assetIds: this.selectedIssueLetterAssets });
        }
        cancelIssueLetter() {
            this.send({ type: "CANCEL_MODAL" });
        }
        printReturnLetter() {
            this.machineService.send({ type: "PRINT_RETURN_LETTER", employeeId: this.assignedAssets.employeeId });
        }
        toggleAllReturnLetterAssets(event) {
            if (event.target.checked) {
                this.selectedReturnLetterAssets = this.assignedAssets.assets.map((a) => a.assetId);
            }
            else {
                this.selectedReturnLetterAssets = [];
            }
        }
        toggleReturnLetterAsset(assetId) {
            const idx = this.selectedReturnLetterAssets.indexOf(assetId);
            if (idx === -1) {
                this.selectedReturnLetterAssets.push(assetId);
            }
            else {
                this.selectedReturnLetterAssets.splice(idx, 1);
            }
        }
        exportReturnLetter() {
            const assets = this.selectedReturnLetterAssets.map((assetId) => ({
                assetId,
                condition: this.returnLetterConditions[assetId] || "",
            }));
            this.send({ type: "EXPORT_RETURN_LETTER", assets });
        }
        cancelReturnLetter() {
            this.send({ type: "CANCEL_MODAL" });
        }
        get assetsData() {
            return AssetMasterModule.getAssetData;
        }
        //Lifecycle
        created() {
            this.machineService.onTransition((state) => {
                this.state = state;
                if (this.state.matches("employeeDetailsLoaded") || this.state.matches("gettingEmployeeAssets")) {
                    this.$bvModal.hide("remove-assignedAssets");
                    this.$bvModal.hide("asset-lookup");
                    this.$bvModal.hide("asset-issue-letter");
                    this.$bvModal.hide("asset-return-letter");
                }
                if (this.state.matches("removeAssignedAsset")) {
                    this.$bvModal.show("remove-assignedAssets");
                }
                if (this.state.matches("assetLookUp")) {
                    this.$bvModal.show("asset-lookup");
                }
                if (this.state.matches("issueLetter") && !this.state.matches("issueLetter.exportingLetter")) {
                    this.selectedIssueLetterAssets = [];
                    this.$bvModal.show("asset-issue-letter");
                }
                if (this.state.matches("returnLetter") && !this.state.matches("returnLetter.exportingLetter")) {
                    this.selectedReturnLetterAssets = [];
                    this.returnLetterConditions = {};
                    this.$bvModal.show("asset-return-letter");
                }
            });
            this.empId = Guid.createEmpty();
            this.machineService.machine.context.empId = this.empId;
            this.machineService.start();
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    AssetAssignment = __decorate([
        Component({
            name: "AssetAssignment",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                DeleteComponent,
            },
        })
    ], AssetAssignment);
    return AssetAssignment;
})();
export default AssetAssignment;
